import { render } from "./BannersComponent.vue?vue&type=template&id=65e8793e&ts=true"
import script from "./BannersComponent.vue?vue&type=script&lang=ts"
export * from "./BannersComponent.vue?vue&type=script&lang=ts"

import "./BannersComponent.vue?vue&type=style&index=0&id=65e8793e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__